// import Vue from "vue";

import Vue from "vue";
import "fullpage.js/vendors/scrolloverflow"; // Optional. When using scrollOverflow:true
// import "./fullpage.scrollHorizontally.min"; // Optional. When using fullpage extensions
import VueFullPage from "vue-fullpage.js";
Vue.use(VueFullPage);

import VueAwesomeSwiper from "vue-awesome-swiper";
// //引入样式
import "swiper/swiper-bundle.css";
Vue.use(VueAwesomeSwiper /* { default options with global component } */);
